<!-- 奖励账户 -->
<template>
  <div id="agentRewardAccount">
    <!--商户-->
    <b-form-group class="find-middle trade-form" v-if="!disabledBroker">
      <label class="trade-form-title left">
        {{ $t("common.clientName") }}</label>
      <v-select class="find-select" v-model="brokerId" :options="brokerList" :disabled="disabledBroker">
        <div slot="no-options">{{ $t("common.noFind") }}</div>
      </v-select>
    </b-form-group>
    <div class="invite-md">
      <div class="invite-md-item">
        <div class="left">
          <div class="title">
            <!-- 经纪人奖励账户 -->
            {{ $t("lanV4.agentAccount") }}
          </div>
          <div class="code-md">
            <div>
              <span class="code-num">
                {{ accountAmount }} {{ accountSymbol }}</span>
              <span class="code-title" @click="handleChangeTranfer" v-if="roleType == 0">
                <!-- 转账 -->
                {{ $t("lanV4.Transfer") }}
              </span>
            </div>
          </div>
          <div class="code-url">
            <div>
              <span class="code-url-text">
                <!-- 当账户余额为0时，系统会暂停发放经纪人的返佣 -->
                {{ $t("lanV4.agentAccountTip") }}</span>
            </div>
          </div>

        </div>
        <div class="center">
          <div class="title">
            <!-- 普通用户直推比例 -->
            {{ $t("lanV4.agentRatio") }}
          </div>
          <div class="invite-card-box">
            <span class="num">{{ baseScale }}%</span>
            <span class="title" @click="handleChange">
              <!-- 设置 -->
              {{ $t("lanV4.agentSet") }}
            </span>
          </div>
        </div>
        <div class="right">
          <img class="img-l" src="../../assets/images/agent_bg11.png" alt="" />
        </div>
      </div>
    </div>
    <div class="invite-data-md">
      <b-row>
        <b-col lg="12">
          <!--搜索uid-->
          <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
            <b-form-input v-model.trim="searchUid" maxLength="9" placeholder=""></b-form-input>
          </b-form-group>
          <!-- 币种 -->
          <b-form-group class="find-middle">
            <label>
              {{ $t("common.symbol") }}
            </label>
            <v-select class="find-select" v-model="symbol" :options="symbolList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
          <!--类型-->
          <b-form-group class="find-middle">
            <label>
              {{ $t("common.type") }}
            </label>
            <v-select class="find-select" v-model="type" :options="typeList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 时间 -->
          <!-- <b-form-group :label="$t('common.date')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
              range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              @change="handleChangeDate" :clearable="false" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group> -->
          <b-form-group :label="$t('common.date')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels value-format="yyyy/MM/dd" type="daterange"
              range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              @change="handleChangeDate" :clearable="false" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group>
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
              class="float-left"
              v-if="pages.total > 0"
              :total-rows="pages.total"
              :perPage="pages.size"
              :pageOptions="pages.options"
              :currentPage="pages.page"
              @initialize="pageChange"
              layout="total,sizes"
            >
            </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass" :default-sort="{ prop: '', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!--  序号 -->
            <el-table-column prop="sort" align="left" :label="$t('common.sort')">
            </el-table-column>
            <!--   uid/账户-->
            <el-table-column prop="uidOrAccount" align="right" width="380" :label="$t('lanV4.agentUidAccount')">
              <template slot-scope="scope">
                <span class="word-wp">
                  {{ scope.row.uidOrAccount }}
                </span>
              </template>
            </el-table-column>
            <!--  类型-->
            <el-table-column prop="typeStr" align="right" :label="$t('common.type')">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.typeStr }}
                </span>
              </template>
            </el-table-column>
            <!-- 币种 -->
            <el-table-column prop="coin" align="right" :label="$t('common.symbol')">
            </el-table-column>
            <!--  金额-->
            <el-table-column align="right" :label="$t('common.money')">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.amount > 0">
                  +{{ scope.row.amount }}
                </span>
                <span class="red" v-if="scope.row.amount < 0">
                  {{ scope.row.amount }}
                </span>
                <span v-if="scope.row.amount == 0">
                  {{ scope.row.amount }}
                </span>
              </template>

            </el-table-column>
            <!--  时间-->
            <el-table-column prop="ctime" align="right" :label="$t('common.date')">
              <template slot-scope="scope">
                <span class="mar-r-10">
                  {{ scope.row.ctime }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>
    <!-- 普通用户直推比例设置 -->
    <b-modal v-model="cashBackModalShow" :title="$t('lanV4.agentRatioSet')" centered scrollable no-close-on-backdrop
      @hide="onReset">
      <div id="futuresFeeUserModal" class="body-content agentModal">
        <!-- 普通用户直推比例设置 -->
        <b-row class="line">
          <b-col>
            <label>{{ $t("lanV4.agentRatio") }} </label>
            <b-input-group>
              <b-form-input class="append-input" v-model.trim="$v.form.feeDiscount.$model" autocomplete="off"
                :state="chkState('feeDiscount')" :placeholder="$t('lanV4.RebateratiocashMaxTip', {
      feeDiscountMin: this.form.feeDiscountMin,
      feeDiscountMax: this.form.feeDiscountMax,
    })
      ">
              </b-form-input>
              <div class="append">%</div>
            </b-input-group>
            <p style="color: #93979d !important; margin: 0; margin-top: 4px">
              <!-- 说明-->
              {{ $t("lanV4.explain") }}:
            </p>
            <p style="color: #93979d !important; margin: 0; margin-top: 4px">
              <!-- 1. 用于设置本商户普通用户推荐好友获得合约交易返佣的比例 -->
              {{ $t("lanV4.explainTip1") }}
            </p>
            <p style="color: #93979d !important; margin: 0; margin-top: 4px">
              <!-- 2.此金额若配置为0，则不支持普通用户返佣 -->
              {{ $t("lanV4.explainTip2") }}
            </p>
            <!-- 请输入直推比例 -->
            <p v-if="!$v.form.feeDiscount.required" class="text-danger">
              {{
      $t("lanV4.RebateratiocashMax", {
        feeDiscountMin: this.form.feeDiscountMin,
        feeDiscountMax: this.form.feeDiscountMax,
      })
    }}
            </p>
            <!-- 超过可输入范围 -->
            <p class="text-danger" style="margin-bottom: 0px" v-if="!$v.form.feeDiscount.proofValue">
              <!-- 请输入0.00～%s范围内的两位小数！ -->
              {{
      $t("lanV4.RebateratiocashMax", {
        feeDiscountMin: this.form.feeDiscountMin,
        feeDiscountMax: this.form.feeDiscountMax,
      })
    }}
            </p>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="primary" @click="handleSubmit">{{
      $t("common.save")
    }}</b-button>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
      $t("common.cancel")
    }}</b-button>
      </template>
    </b-modal>

    <agentRewardAccountModal v-if="modalShow" :modalShow="modalShow" :brokerId="brokerId"
      @changeModalShow="changeModalShow" @changeModalType="changeModalType">
    </agentRewardAccountModal>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
      $t("exportsModal.text2", {
        pagesTotal: pages.total,
        maxNum: exportNumLimit,
      })
    }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
      $t("common.cancel")
    }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import { newFixInput, multiply, divide, formatTime, fixInput, formatTimeDay } from "@/apis/newmethods";
import agentRewardAccountModal from "./components/agentRewardAccountModal";

import commonMixin from "@/mixin/common/commonMixin";

export default {
  name: "agentRewardAccount",
  mixins: [commonMixin],
  components: {
    agentRewardAccountModal,
  },
  data() {
    return {
      symbolList: [], //币种列表
      symbol: null,
      accountAmount: null, //账户资产
      accountSymbol: null, //账户资产
      baseScale: null, //直推比例
      addSave: false,
      cashBackModalShow: false,
      form: {
        feeDiscount: null, //返现比例
        feeDiscountMax: 100, //直推比例最大值
        feeDiscountMin: 0, //直推比例最小值
      },
      brokerId: null, // 商户
      brokerList: [],
      loading: true,
      submitFlag: true, //提交防连点
      modalShow: false, //转账弹窗

      searchUid: null,//uid
      type: null,//类型
      dateArray: [new Date().getTime() - 86400000 * 30, new Date().getTime()],
      beginDate: null,
      endDate: null,
      notData: true,
      loading: true,
      tableList: [],
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "", //默认排序字段
      sortSet: 1, //默认倒序
      isexportIng: true,
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

    };
  },
  computed: {
    lan() {
      return this.$store.state.baseData.language;
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    typeList() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.agentTransfer"), //划转
          value: 1,
        },
        {
          label: this.$t("lanV4.agentGrant"), //发放
          value: 0,
        },
      ];
    },
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },


  watch: {
    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    "form.feeDiscount"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.feeDiscount = newFixInput(v, 2, {
            num: true,
            ints: 5,
          });
        });
      }
    },
    brokerId(v) {
      this.getData();
      this.getTableData()
    },
  },
  created() {
    this.type = this.typeList[0]
    this.getLastMonthOne()
    this.getBrokerList();
    this.handleChangeDate()

  },
  validations: {
    form: {
      // 返现比例
      feeDiscount: {
        required: requiredIf(function () {
          return this.addSave;
        }),
        proofValue: function (v) {
          if (v === "-0") {
            return false;
          }
          if (v) {
            return (
              Number(v) >= this.form.feeDiscountMin &&
              Number(v) <= this.form.feeDiscountMax
            );
          }
          return true;
        },
      },
    },
  },
  methods: {

    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "value":
          return "enNum";
      }
    },

    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },
    // 转账
    handleChangeTranfer() {
      this.modalShow = true;
    },
    // 设置
    handleChange() {
      this.cashBackModalShow = true;
      this.form.feeDiscount = this.baseScale;
    },
    // 查看弹窗关闭
    handlePopoverClose() {
      document.getElementById("agentRewardAccount").click();
    },
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          // if (this.roleType === 1) {
          //   arr.push({ label: this.$t("common.all"), value: null });
          // }
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            this.brokerId = arr[0];
            this.getSmbolList()
            this.getData();
            this.getTableData()
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 获取保证金币种
    getSmbolList() {
      this.$http({
        url: this.$store.state.url.agent.getMarginCoinList,
        params: {
          companyId: this.brokerId ? this.brokerId.value : null,
          justUsdt: 0, //传1只显示usdt或者混合云usdt1753
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (data.coinList.length) {
            data.coinList.map((item) => {
              if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
              if (this.roleType == 3 || this.roleType == 4) {
                // 经纪人展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
            });
          }
          this.symbolList = arr;
          this.symbol = this.symbolDefaultValue();
          this.getTranferAccountList();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    symbolDefaultValue() {
      let data = [];
      if (this.symbolList && this.symbolList.length) {
        data = this.symbolList[0];
        this.symbolList.forEach((item) => {
          if (item.value === "USDT") {
            data = item;
          }
        });
      }
      return data;
    },

    // 最近一月
    getLastMonthOne() {
      var end = new window.Date(new window.Date());
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end = year + "-" + month + "-" + day;
      var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.start = year - 1 + "-" + 12 + "-" + day;
      } else {
        var startMonthDay = new window.Date(
          year,
          parseInt(month) - 1,
          0
        ).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.start =
              year +
              "-" +
              (month - 1) +
              "-" +
              (startMonthDay - (endMonthDay - day));
          } else {
            dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
          }
        } else {
          dateObj.start = year + "-" + (month - 1) + "-" + day;
        }
      }
      this.beginDate = new window.Date(
        dateObj.start.replace(/-/g, "/")
      ).getTime();
      this.endDate = new window.Date(dateObj.end.replace(/-/g, "/")).getTime();

      this.dateType = 1;
      this.dateArray = [
        formatTimeDay(this.beginDate),
        formatTimeDay(this.endDate),
      ];
    },
    // 获取看板数据
    getData() {
      const paramsData = {
        companyId: this.brokerId ? this.brokerId.value : undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.account_info,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          data.forEach((item) => {
            if (item.type == 118) {
              // 经纪人奖励账户
              this.accountAmount = item.balance;
              this.baseScale = multiply(item.baseScale, 100);
              this.accountSymbol = item.coin;
            }
          });

        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 获取表格数据列表
    getTableData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        uid: this.searchUid,
        startTime: this.dateArray
          ? new window.Date(this.beginDate).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(this.endDate).getTime()
          : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        type: this.type ? this.type.value : null,
        isExport: 0,
        companyId: this.brokerId ? this.brokerId.value : undefined,
        coin: this.symbol ? this.symbol.value : null
      };
      this.$http({
        url: this.$store.state.url.agent.bonus_transactions,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data.pageInfo);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, rows } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (rows && rows.length) {
        rows.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            fromuid: item.fromUid,
            touid: item.toUid,
            uidOrAccount: item.uidOrAccount,
            type: item.type,
            typeStr: item.typeStr,
            amount: item.amount,
            ctime: item.ctime ? formatTime(item.ctime) : "--", //注册时间
            coin: item.coin
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          uid: this.searchUid,
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          type: this.type ? this.type.value : null,
          isExport: 1,
          companyId: this.brokerId ? this.brokerId.value : undefined,
        };

        this.outExcel(
          this.$store.state.url.agent.bonus_transactions,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    // 查询
    query() {
      this.getTableData()
    },
    // 保存
    handleSubmit() {
      this.addSave = true;
      if (!this.validate()) {
        // this.$bus.$emit("alert", {
        //   type: "error",
        //   message: this.$t("lanV4.infoErr"),
        // });
        return false;
      }
      if (!this.submitFlag) {
        return;
      }
      this.submitFlag = false;
      this.$http({
        url: this.$store.state.url.agent.direct_scale_set,
        params: {
          baseScale: divide(this.form.feeDiscount, 100),
          companyId: this.brokerId ? this.brokerId.value : null,
        },
      }).then(({ code, msg }) => {
        this.submitFlag = true;
        if (code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: msg });
          this.cashBackModalShow = false;
          this.getData();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 重置
    reset() {
      this.searchUid = null
      this.type = this.typeList[0]
      this.getLastMonthOne()
      this.handleChangeDate();
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getTableData(v);
    },
    onReset() {
      this.form.feeDiscount = null;
      this.cashBackModalShow = false;
      this.addSave = false;
      this.exportsModalShow = false
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
    changeModalShow(data) {
      this.modalShow = data;
    },
    changeModalType(data) {
      this.modalType = data;
    },
  },
};
</script>


<style lang="scss">
#agentRewardAccount {
  .col-form-label {
    padding-bottom: calc(0.375rem + 2px) !important;
  }



  .trade-form {
    position: relative;
    z-index: 110;

    &>div {
      display: flex;
    }

    // 下拉框
    .vs__dropdown-toggle {
      background: #fff !important;
      border-color: #F3F4F8 !important;
      border-radius: 6px !important;
      height: 32px !important;


    }
  }

  .trade-form-title {
    color: #8B909A;
    font-family: HarmonyOS-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-right: 8px;
    margin-top: 8px;
  }

}
</style>
<style lang="scss" scoped>
#agentRewardAccount {
  .invite-md {
    display: flex;
    justify-content: space-between;

    .invite-md-item {
      width: 100%;
      height: 118px;
      border-radius: 16px;
      display: flex;
      // justify-content: space-between;
      background: linear-gradient(274deg,
          rgba(9, 91, 232, 0.13) 7.88%,
          rgba(255, 255, 255, 0.9) 60.23%);
      position: relative;

      .left {
        margin-left: 24px;
        z-index:100;

        .title {
          color: #8b909a;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          font-family: HarmonyOS-Medium;
          margin-top: 24px;
          margin-bottom: 8px;
        }

        .code-md {
          position: relative;

          .code-title {
            color: #095be8;
            font-family: HarmonyOS-Medium;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            cursor: pointer;
          }

          .code-num {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-right: 8px;
            margin-left: 1px;
          }
        }

        .code-url {
          position: relative;
          margin-bottom: 8px;

          .code-url-text {
            color: #ffad2b;
            font-family: HarmonyOS-Regular;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-right: 8px;
          }
        }

        .copyInput {
          position: absolute;
          opacity: 0;
        }

        .role-md {
          display: flex;
          margin-top: -10px;

          .role-md-l {
            width: 130px;
          }

          .role-md-item {
            ul {
              li {
                line-height: 1;
                white-space: nowrap;

                .name {
                  color: #8b909a;
                  font-family: HarmonyOS-Regular;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  margin-right: 8px;

                  a {
                    color: #8b909a;
                    text-decoration: none;
                    border-bottom: 1px dotted;
                  }
                }

                .val {
                  color: #24324c;
                  font-family: HarmonyOS-Bold;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                }

                .action {
                  color: #095be8;
                  font-family: HarmonyOS-Bold;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-left: 8px;
                  cursor: pointer;
                }

                margin-bottom: 9px;
              }
            }
          }
        }
      }

      .center {
        margin-left: 73px;
        z-index:100;

        .title {
          color: #8b909a;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          font-family: HarmonyOS-Medium;
          cursor: pointer;
          margin-top: 24px;
        }

        .invite-card-box {
          margin-top: 8px;

          .num {
            color: #24324c;
            font-family: HarmonyOS-Bold !important;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-right: 8px;
          }

          .title {
            color: #095be8;
            font-family: HarmonyOS-Medium;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
      }

      .right {


        .img-l {
          //   margin-top: 13px;
          //   margin-right: 18.53px;
          position: absolute;
          right: 17px;
          top: -162px;
        }

        .img-r {
          margin-top: 16px;
          margin-right: 17.38px;
        }
      }
    }
  }

  .invite-data-md {
    width: 100%;
    border-radius: 16px;
    background: url("../../assets/images/agent_bg2.png") no-repeat;
    margin-top: 10px;
    padding: 24px 24px 24px 24px;
    line-height: 1;
    margin-bottom: 10px;
    background-size: 100% 100%;


  }
}
</style>